import { IView } from "../View";
import { Dictionary } from "../Interfaces/Dictionary";

export class ViewFactory {

    private static ViewRegistry: Dictionary<any> = {};

    static setRegistry(registry: Dictionary<any>): void {
        this.ViewRegistry = registry;
    }

    static createView(name: string): IView {
        var view = this.ViewRegistry[name];
        if (!view) {
            throw `Could not find view: ${name}`;
        }

        return new view();
    }
}


// WEBPACK FOOTER //
// ./www/js/Core/Factories/ViewFactory.ts